import React, { Component } from 'react';
import localStorage from '../LocalStorage';
import { UserRole } from '../UserRole';

import { getCompaniesReducedList, getPharmaciesForSingleCompany } from '../../Companies/epics-companies';
import { getCurrentUser } from '../../Users/epics-users';

export class CompanySelectV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companies: []
        };
    }

    componentDidMount() {
        this.getCompaniesList(this.props.role);
    }

    getCompaniesList = userRle => {
        switch (userRle) {
            case UserRole.ADMIN:
                getCompaniesReducedList()
                    .then(response => {
                        this.setState({ companies: response.companies });
                        this.props.handler(response.companies[0].id);
                    })
                    .catch(() => {
                        return {};
                    });
                break;
            default:
                getCurrentUser()
                    .then(response => {
                        this.setState({ companies: [response.company] });
                        this.props.handler(response.company.id);
                    })
                    .catch(() => {
                        return {};
                    });
                break;
        }
    };

    changeCompany = event => {
        this.props.handler(event.target.value);
    };

    generateSelect = () => {
        const forbidden = [UserRole.STORE_OWNER, UserRole.PHARMACY_MANAGER, UserRole.PHARMACIST];
        const isDisabled = forbidden.includes(localStorage.getUsernameRole()) || this.props.disabled;
        
        return (
            <select onChange={this.changeCompany} disabled={isDisabled} value={this.props.value} name={this.props.name}>
                {this.state.companies.map(company => {
                    return (
                        <option key={company.id} value={company.id}>
                            {company.name}
                        </option>
                    );
                })}
            </select>
        );
    };

    render() {
        
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}

export class PharmacySelectV2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pharmacies: []
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.company !== this.props.company) {
            this.getPharmaciesList(this.props.role);
        }
    }

    getPharmaciesList = userRole => {
        switch (userRole) {
            case UserRole.ADMIN:
                getPharmaciesForSingleCompany(this.props.company)
                    .then(response => {
                        this.setState({
                            pharmacies: response.pharmacies
                        });
                        this.props.handler(response.pharmacies[0].id);
                    })
                    .catch(() => {
                        return {};
                    });
                break;
            case UserRole.STORE_OWNER:
                getPharmaciesForSingleCompany(this.props.company)
                    .then(response => {
                        this.setState({
                            pharmacies: response.pharmacies
                        });
                        this.props.handler(response.pharmacies[0].id);
                    })
                    .catch(() => {
                        return {};
                    });
                break;
            default:
                getCurrentUser()
                    .then(response => {
                        this.setState({ pharmacies: [response.pharmacy] });
                        this.props.handler(response.pharmacy.id);
                    })
                    .catch(() => {
                        return {};
                    });
                break;
        }
    };

    changePharmacy = event => {
        this.props.handler(event.target.value);
    };

    generateSelect = () => {
        const forbidden = [UserRole.PHARMACY_MANAGER, UserRole.PHARMACIST];
        const isDisabled = forbidden.includes(localStorage.getUsernameRole());
        return (
            <select onChange={this.changePharmacy} disabled={isDisabled} value={this.props.value} name={this.props.name}>
                {this.state.pharmacies.length
                    ? this.state.pharmacies.map(pharmacy => {
                          return (
                              <option key={pharmacy.id} value={pharmacy.id}>
                                  {pharmacy.name}
                              </option>
                          );
                      })
                    : null}
            </select>
        );
    };

    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/customModules/Common/form/SelectsV2.js